import { Container, Toolbar } from '@mui/material';
import Box from '@mui/material/Box';
import ContactUsFloatButton from '../../components/buttons/ContactUsFloatButton';
import { useAuthContext } from '../login/AuthContext';
import MyNetworkPublicHeader from './MyNetworkPublicHeader';
import MyNetworkExploreList from './explore/MyNetworkExploreList';

const MyNetworkPublicSection = () => {
  const { loginContext } = useAuthContext();

  return (
    <>
      <MyNetworkPublicHeader />
      <Toolbar />
      <Box
        sx={{
          paddingTop: 2,
        }}
      >
        <Container maxWidth="lg">
          <MyNetworkExploreList updateNotifications={() => undefined} />
        </Container>
      </Box>
      <ContactUsFloatButton
        brandName={loginContext?.brandName}
        customerSupportPhone={loginContext?.customerSupportPhone}
      />
    </>
  );
};

export default MyNetworkPublicSection;
